export default function HudLoader() {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-virtus-bg">
            <div className="text-center">
                <div className="mb-4 font-mono text-[10px] tracking-[0.3em] text-virtus-orange uppercase">
                    VIRTUS // BOOTING
                </div>
                <div className="mx-auto h-10 w-10 border-2 border-virtus-orange border-t-transparent animate-spin" />
            </div>
        </div>
    );
}
